namespace Ir.Components.Workbook.WorkbookShare {
    interface IWorkbookShareViewModel {
        addAllOptions: DevExpress.ui.dxButton.Properties;
        addOptions: DevExpress.ui.dxButton.Properties;

        removeAllOptions: DevExpress.ui.dxButton.Properties;
        removeOptions: DevExpress.ui.dxButton.Properties;

        availableOptions: DevExpress.ui.dxDataGrid.Properties;
        availableComponent: DevExpress.ui.dxDataGrid;
        selectedOptions: DevExpress.ui.dxDataGrid.Properties;
        selectedComponent: DevExpress.ui.dxDataGrid;

        hiddenMobile: boolean;

        save: Function;
    }

    interface IWorkbookShareParams {
        access: Array<UserOrGroupAccessModel>;
        popup: DevExpress.ui.dxPopup;
        workbookId: number;
        callback: (obj) => boolean;
    }

    class UserOrGroupAccessModel {
        entityType: EntityTypeEnum;
        name: string;
        id: number;
        orgId: number;
        fullName: string;
        hasAccess: boolean;
        shareType: ShareTypeEnum;
    }
    enum EntityTypeEnum {
        User = 1,
        Group = 2
    }
    enum ShareTypeEnum {
        Viewer,
        Editor,
        Restricted
    }

    export function getViewModel(this: IWorkbookShareViewModel, params: IWorkbookShareParams) {
        let self = this;
        let availableDataSource = params.access.filter(x => !x.hasAccess);
        let selectedDataSource = params.access.filter(x => x.hasAccess);

        this.hiddenMobile = isMobile();
        this.addAllOptions = {
            icon: 'chevrondoubleright',
            width: 50,
            onClick(e) {
                add(self.availableComponent.getDataSource().items());
            }
        }
        this.removeAllOptions = {
            icon: 'chevrondoubleleft',
            width: 50,
            onClick(e) {
                remove(self.selectedComponent.getDataSource().items());
            }
        }
        this.addOptions = {
            icon: 'chevronnext',
            width: 50,
            onClick(e) {
                add(self.availableComponent.getSelectedRowsData());
            }
        }
        this.removeOptions = {
            icon: 'chevronprev',
            width: 50,
            onClick(e) {
                remove(self.selectedComponent.getSelectedRowsData());
            }
        }

        this.availableOptions = {
            height: "calc(100% - 20px)",
            showBorders: true,
            showColumnHeaders: false,
            noDataText: "",
            selection: {
                mode: "multiple",
                showCheckBoxesMode: "always"
            },
            paging: {
                enabled: false
            },
            searchPanel: {
                visible: true,
                width: 285
            },
            dataSource: availableDataSource,
            columns: [
                {
                    dataField: "fullName",
                    calculateDisplayValue(rowData) {
                        return rowData.fullName && rowData.fullName !== "" ? `${rowData.fullName} (${rowData.name})` : `${rowData.name}`;
                    }
                }
            ],
            onInitialized(e) {
                self.availableComponent = e.component;
            },
            onRowPrepared(e) {
                if (e.rowType === "data") {
                    e.rowElement.addClass(e.data.entityType === ShareTypeEnum.Editor ? "userOption" : "groupOption");
                }
            }
        };
        this.selectedOptions = {
            height: this.hiddenMobile ? "100%" : "calc(100% - 20px)",
            showBorders: true,
            showColumnHeaders: false,
            noDataText: "",
            selection: {
                mode: "multiple",
                showCheckBoxesMode: "always"
            },
            editing: {
                mode: 'cell',
                allowUpdating: true,
                allowAdding: false,
                allowDeleting: false,
            },
            paging: {
                enabled: false
            },
            searchPanel: {
                visible: true,
                width: 285
            },
            dataSource: isMobile() ? params.access : selectedDataSource,
            selectedRowKeys: isMobile() ? params.access.filter(x => x.hasAccess) : undefined,
            columns: [
                {
                    allowEditing: false,
                    dataField: "fullName",
                    calculateDisplayValue(rowData) {
                        return rowData.fullName && rowData.fullName !== "" ? `${rowData.fullName} (${rowData.name})` : `${rowData.name}`;
                    }
                },
                {
                    dataField: "shareType",
                    lookup: {
                        dataSource: [
                            { id: ShareTypeEnum.Viewer, name: "Viewer" },
                            { id: ShareTypeEnum.Editor, name: "Editor" },
                            { id: ShareTypeEnum.Restricted, name: "Restricted" }
                        ],
                        displayExpr: 'name',
                        valueExpr: 'id'
                    },
                    showEditorAlways: true,
                    width: 110
                }
            ],
            onInitialized(e) {
                self.selectedComponent = e.component;
            },
            onRowPrepared(e) {
                if (e.rowType === "data") {
                    e.rowElement.addClass(e.data.entityType === ShareTypeEnum.Editor ? "userOption" : "groupOption");
                }
            },
            onSelectionChanged(e) {
                var keys = [];
                if (e.currentSelectedRowKeys.length && e.currentSelectedRowKeys.some(notOkToSelect)) {
                    e.currentSelectedRowKeys.splice(0, e.currentSelectedRowKeys.length);
                    e.component.deselectRows(keys);
                }
                function notOkToSelect(key) {
                    var result = false;
                    if (key < 6) {
                        keys.push(key);
                        result = true;
                    }
                    return result;
                }
            }
        };
        
        let add = function (rows) {
            availableDataSource = availableDataSource.filter(x => rows.find(r => r.id === x.id) === undefined);
            self.availableComponent.option("dataSource", availableDataSource);

            rows.forEach(function (row) {
                selectedDataSource.push(row);
            });
            self.selectedComponent.option("dataSource", selectedDataSource);
        }
        let remove = function (rows) {
            selectedDataSource = selectedDataSource.filter(x => rows.find(r => r.id === x.id) === undefined);
            self.selectedComponent.option("dataSource", selectedDataSource);

            rows.forEach(function (row) {
                row.ShareType = 0;
                availableDataSource.push(row);
            });
            self.availableComponent.option("dataSource", availableDataSource);
        }

        params.callback({
            save: function () {
                let success = false;
                let selectedEntities = [];
                let selectedVals = self.selectedComponent.option("dataSource") as [];
                if (isMobile()) {
                    selectedVals = self.selectedComponent.getSelectedRowKeys() as any;
                }

                if (selectedVals.length > 0) {
                    selectedVals.forEach(function (data: any) {
                        selectedEntities.push({
                            id: data.id,
                            entityType: data.entityType,
                            shareType: data.shareType
                        });
                    });
                }

                let o = {
                    url: urlConfigs.user + "UpdateUserAccess",
                    data: {
                        userIds: selectedEntities,
                        workbookId: params.workbookId,
                        mappingId: 0
                    },
                    dataType: "json",
                    async: false
                } as RequestServerParams;
                o.successFunction = function (data, e) {
                    success = true;
                };
                o.failureFunction = function (textStatus, errorThrown, errorItem: IError) {
                    errorItem.userMessage = "Failed to update user accesses";
                    irGlobal.defaultErrorFunction(errorItem.userMessage, textStatus, errorThrown);
                };

                irGlobal.requestServer(o);

                return success;
            }
        })
    }
}